
import { Component, Vue } from 'vue-property-decorator'
import { VueCropper } from 'vue-cropper'
import { uploadBase64Image } from '@/utils/util'
import { Getter } from 'vuex-class'
import { pxToVw } from '@/utils/pxToVw'
import { editStoreInfo } from '@/api/store'

@Component({
  name: 'EditIcon',
  components: {
    VueCropper
  }
})
export default class EditIcon extends Vue {
  @Getter topSafetyHeight!: number
  @Getter companyId!: string
  @Getter info!: any
  imageUrl = require('@/assets/images/store/noData.png')
  filePath = ''

  created() {
    // 检查来源
    const source = this.$route.query.source
    if (source === 'camera') {
      const base64 = sessionStorage.getItem('temp_camera_photo')
      console.log('base64', base64)
      if (base64) {
        this.imageUrl = base64
        // 清理缓存
        sessionStorage.removeItem('temp_camera_photo')
      }
    } else {
      // 从路由参数获取图片路径
      this.filePath = this.$route.query.filePath as string || ''
      if (this.filePath) {
        this.imageUrl = this.$downloadUrl(this.filePath)
      }
    }
  }

  get topSafetyHeightCss(): string {
    return pxToVw(this.topSafetyHeight)
  }

  onCancel() {
    // 返回上一页
    this.$router.back()
  }

  onRotate() {
    // 左旋转图片
    ;(this.$refs.cropper as any).rotateLeft()
  }

  async onConfirm() {
    try {
      // 显示上传提示
      this.$toast({
        message: '上传中...',
        duration: 0
      })

      // 获取裁剪后的 base64 图片数据
      ;(this.$refs.cropper as any).getCropData(async (base64Image: string) => {
        try {
          // 使用公共方法上传图片（使用时间戳命名）
          const result = await uploadBase64Image(base64Image, undefined, '1')
          this.$toast.clear()
          
          if (result.success && result.filePath) {
            // 如果是从店铺信息页面进入，调用更新接口
            if (this.$route.query.fromSource === 'storeInfo') {
                try {
                    const updateRes = await editStoreInfo({
                        storeId: this.companyId,
                        storeHeadPortrait: result.filePath
                    })
                    if (updateRes.code === '000000') {
                        this.$toast.success('修改成功')
                        // 更新store信息
                        const logoUrl = window.location.origin + this.$downloadUrl(result.filePath) // 完整的url地址
                        this.$store.dispatch('GetInfo', { ...this.info, logoUrl })
                        this.$router.back()
                    } else {
                        this.$toast.fail(updateRes.msg || '修改失败')
                    }
                } catch (e) {
                    console.error(e)
                    this.$toast.fail('修改失败')
                }
                return
            }

            // 上传成功，返回到创建店铺页面并传递文件路径
            // 更新本地缓存，确保返回时能读取到最新图片
            try {
              const cachedFormStr = sessionStorage.getItem('createStoreFormCache')
              let cachedForm = {}
              if (cachedFormStr) {
                cachedForm = JSON.parse(cachedFormStr)
              }
              // @ts-ignore
              cachedForm.storeHeadPortrait = result.filePath
              sessionStorage.setItem('createStoreFormCache', JSON.stringify(cachedForm))
            } catch (e) {
              console.error('更新缓存失败', e)
            }
            this.$router.back()
          } else {
            this.$toast.fail(result.message || '上传失败')
          }
        } catch (error) {
          this.$toast.clear()
          this.$toast.fail('上传失败，请重试')
          console.error('上传文件失败:', error)
        }
      })
    } catch (error) {
      this.$toast.clear()
      this.$toast.fail('处理图片失败，请重试')
      console.error('处理图片失败:', error)
    }
  }
}
